<template>
  <div>
    <MainForm
      :name="FORM_NAMES.insurances"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Insurances"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.eligibility"
        ui-title="Profile Information"
        ui-subtitle="Tell us a little bit more about you"
        ui-error-message="Please, review the fields marked in red"
        ui-button-text="Next"
      >
        <FieldsetFullName />

        <FieldsetEmail />

        <FieldsetMobilePhone />
      </StepModel>

      <StepOtp
        :change-phone-action="goToStep(STEP_NAMES.eligibility)"
      />

      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.appointment"
        ui-title="Schedule your appointment"
        ui-subtitle="You are all set!
        Now we just need to meet you in person to complete the process."
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetAppointmentDate
          :name="FIELDSET_NAMES.appointmentSetDate"
        />

        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.appointmentSetAddress"
          ui-columns="2"
          ui-title="We’ll meet in your office. Where is it?"
        >
          <UiWrapper
            :name="FIELD_NAMES.companyName"
            label="Company name"
            :validations="[
              {
                'errorMessage': 'This field must not be empty',
                'condition': notEmptyCondition,
                'name': 'companies-filled',
              },
            ]"
          >
            <Suggest
              data-forced-fullwidth="true"
              :exact-match="false"
              placeholder="Company name"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCompanies"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.address"
            label="Address line 1"
          >
            <InputText
              data-forced-fullwidth="true"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.additionalInfo"
            label="Address line 2"
            optional
          >
            <InputText />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.nearestLandmark"
            label="Nearest landmark"
            optional
          >
            <InputText />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.areaStreetName"
            label="Area/Street name"
          >
            <InputText
              data-forced-fullwidth="true"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.poBox"
            label="PO Box"
          >
            <InputText />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.emirate"
            label="Emirate"
          >
            <Dropdown
              placeholder="Emirate"
              :options="EMIRATE_LIST"
            />
          </UiWrapper>
        </FieldsetModel>
         <FieldsetEmiratesIdNumber />
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.consent">
      <UiWrapper :name="FIELD_NAMES.consent">
        <CheckWrapper>
          <Expandable
            excerpt="I, hereby consent to..."
            :extra-text="`I, hereby consent to (i) leave Deem’s website, and get redirected to a 
            third party website. Deem makes no representations nor has any supervision or control over 
            the quality, content, reliability or security of the third party website, nor shall Deem be 
            liable for its use. (ii) have read and accept Deem’s Terms and Conditions.`"
          />
        </CheckWrapper>
      </UiWrapper>
    </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
import MainForm from '@/lib/components/main-form';
import StepModel from '@/lib/components/models/step';
import FieldsetModel from '@/lib/components/models/fieldset';

import UiWrapper from '@/forms/components/base/ui-wrapper';

import {
  InputText,
  Dropdown,
  Suggest,
  Expandable
} from '@dunia/ui';

import FormComponentMixin from '@/lib/mixins/form-component-mixin';

import StepOtp from '@/forms/components/shared/steps/otp';

import FieldsetEmail from '@/forms/components/shared/fieldsets/email';
import FieldsetMobilePhone from '@/forms/components/shared/fieldsets/mobile-phone';
import FieldsetFullName from '@/forms/components/shared/fieldsets/full-name';
import FieldsetAppointmentDate from '@/forms/components/shared/fieldsets/appointment-date';
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import FieldsetEmiratesIdNumber from "@/forms/components/shared/fieldsets/emirates-id-number";
import {
  END_PAGE_TITLE,
} from '@/forms/constants/insurances-logic';

export default {
  name: 'Insurances',

  components: {
    MainForm,
    StepModel,
    FieldsetModel,
    UiWrapper,
    InputText,
    Dropdown,
    Suggest,
    StepOtp,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    FieldsetAppointmentDate,
    CheckWrapper,
    Expandable,
    FieldsetEmiratesIdNumber
  },

  mixins: [FormComponentMixin],

  data: () => ({
    END_PAGE_TITLE,
  }),
   mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "UA-148233917-1");
  },
  methods: {
    finishCallback() {
      this.showEndPage(
        {
          title: `Thanks ${this.userName}! ✌️`,
          subtitle: 'We look forward to meeting you. We will send you an email with your appointment confirmation and document checklist shortly.',
          actionNameEndForm: 'Thanks',
        },
      );
    },

    rejectOffer() {
      this.goToForm('Loan offer rejected');
    },
  },
};
</script>
